import { Component, Inject } from '@angular/core';

import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { ERROR, ERROR_LIGHT } from '../../constants/snackbar.constants';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { ErrorModalComponent } from '../error-modal/error-modal.component';
import { AUTO_GENERATE_MESSAGES } from '../genai-quality-rating/constants';

@Component({
    selector: 'app-snackbar',
    imports: [MatTooltipModule],
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss']
})
export class SnackbarComponent {
  ERROR: string = ERROR;
  ERROR_LIGHT: string = ERROR_LIGHT;
  AUTO_GENERATE_MESSAGES = AUTO_GENERATE_MESSAGES;
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,
    public dialog: MatDialog,) { }
    openErrorPopup() {
      this.dialog.open(ErrorModalComponent, {
        data: this.data.error,
        autoFocus: false,
        width: '50%'
      });
    }
}
